
import store from '@/store';
import { VForm } from 'vuetify/components/VForm';
import { computed, defineComponent, ref } from 'vue';
import CustomTextField from '@/components/vuetifyComponents/CustomTextField.vue';
import CustomPasswordField from '@/components/vuetifyComponents/CustomPasswordField.vue';
import CustomButton from '@/components/vuetifyComponents/CustomButton.vue';

export default defineComponent({
    name: 'LoginFormComponent',
    components: {
        CustomTextField,
        CustomPasswordField,
        CustomButton,
    },
    setup() {
        const formValid = ref(false); // Tracks form validity
        const form = ref<InstanceType<typeof VForm> | null>(null); // Typed form ref
        const formData = ref({
            mobile: '',
            password: '',
        });

        const phoneRules = [
            (v: string) => !!v || 'شماره موبایل الزامی است',
        ];

        const passwordRules = [
            (v: string) => !!v || 'گذرواژه الزامی است',
        ];

        const getAuthLoading = computed(() => store.getters['auth/getAuthLoading']);

        const submitLoginForm = async () => {
            const validation = await form.value?.validate();
            if (!validation?.valid || getAuthLoading.value) return;

            const loginForm = {
                mobile: formData.value.mobile,
                password: formData.value.password,
            };
            store.state.auth.loginForm.mobile = loginForm.mobile;
            store.state.auth.loginForm.password = loginForm.password;
            await store.dispatch('auth/submitLoginForm', loginForm);
        };

        return {
            formValid,
            form: form,
            formData,
            phoneRules,
            passwordRules,
            submitLoginForm,
            getAuthLoading,
        };
    },
});
